import React from 'react';
import { Box } from 'components/grid';
import { BreadcrumbLinkWrapper } from '../link';
import { OnlyDesktop, OnlySmall } from 'components/containers';
import { colors as Colors } from 'constants/colors';

const Breadcrumbs = props => {
  const { breadcrumbs, margin, smallmargin } = props;
  const breadcrumbsForSmall =
    breadcrumbs.length > 1
      ? breadcrumbs.slice(breadcrumbs.length - 2, breadcrumbs.length)
      : breadcrumbs.slice();

  return (
    <Box column margin={margin}>
      <OnlyDesktop>
        {breadcrumbs.map(({ name, truncatedName, url }, index) => {
          const linkText = breadcrumbs.length > 4 ? truncatedName : name;
          const key = url + index;
          return url ? (
            <BreadcrumbLinkWrapper key={key} to={url}>
              {linkText}
            </BreadcrumbLinkWrapper>
          ) : (
            <BreadcrumbLinkWrapper key={key} as="span" to={url} color={Colors.SLIGHTLY_GARY}>
              {linkText}
            </BreadcrumbLinkWrapper>
          );
        })}
      </OnlyDesktop>
      <OnlySmall margin={smallmargin ? smallmargin : '-2rem'}>
        {breadcrumbs.length > 2 && (
          <BreadcrumbLinkWrapper as="span" to="">
            ...
          </BreadcrumbLinkWrapper>
        )}
        {breadcrumbsForSmall.map(({ name, truncatedName, url }, index) => {
          const key = url + index;
          return url ? (
            <BreadcrumbLinkWrapper key={key} to={url}>
              {truncatedName}
            </BreadcrumbLinkWrapper>
          ) : (
            <BreadcrumbLinkWrapper key={key} as="span" to={url} color={Colors.SLIGHTLY_GARY}>
              {truncatedName}
            </BreadcrumbLinkWrapper>
          );
        })}
      </OnlySmall>
    </Box>
  );
};

export default Breadcrumbs;
